/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { getFormValues, reduxForm, reset, submit } from 'redux-form';
import { useLocation } from 'react-router';
import { ModalWindow } from '../../../../semantic-ui/components/modal-window';
import ModalFooterButtons from '../../../../semantic-ui/components/modal-window/modal-footer-buttons';
import { validate } from './utils';
import { FORM_NAME } from './constants';
import {
	getGroupsOptionsSelector,
	getIsLoadingSelector,
	getIsCollectionGroupListLoadingSelector,
	getIsCollectionWayListLoadingSelector,
} from '../../selectors';
import { ChangeGroupModalForm } from './change-group-modal-form';
import { removeModalQuery } from '../../../../utils/removeModalQuery';
import { groupToGroupAction, orderGroupToGroupAction, orderWayToGroupAction, wayToGroupAction } from './actions';
import { useInjectSaga } from '../../../../utils/injectSaga';
import saga from './saga';

const ChangeGroupModalWrapper = ({
	onFormSubmit,
	onResetForm,
	formValues,
	onOrderGroupToGroup,
	onOrderWayToGroup,
	onGroupToGroup,
	onWayToGroup,
	isLoading,
	isOrdersGroupListLoading,
	isOrdersWayListLoading,
	groupsOptions,
	isModalShown,
	setIsModalShown,
	collection,
	orders,
	group,
	way,
}) => {
	if (!isModalShown) return null;
	useInjectSaga({ key: 'orderGroupsChangeGroupContainerSaga', saga });

	const { search } = useLocation();

	const query = new URLSearchParams(search);

	const loading =
		isLoading ||
		Boolean(isOrdersGroupListLoading.find(el => el === group?.id)) ||
		Boolean(isOrdersGroupListLoading.find(el => el === formValues?.group_id)) ||
		Boolean(isOrdersWayListLoading.find(el => el === way?.id)) ||
		Boolean(isOrdersWayListLoading.find(el => el === formValues?.way_id));

	const handleModalCancel = () => {
		setIsModalShown(false);
		onResetForm(FORM_NAME);
	};

	const handleFormSubmit = async () => {
		await onFormSubmit(FORM_NAME);

		if (group) {
			if (orders?.length > 0 || collection?.length > 0) {
				onOrderGroupToGroup({
					searchQuery: removeModalQuery(query.toString()),
					collection,
					orders,
					group,
					to_id: formValues?.group_id,
					callback: handleModalCancel,
				});
			} else {
				onGroupToGroup({
					searchQuery: removeModalQuery(query.toString()),
					group,
					to_id: formValues?.group_id,
					callback: handleModalCancel,
				});
			}
		}

		if (way) {
			if (orders?.length > 0 || collection?.length > 0) {
				onOrderWayToGroup({
					searchQuery: removeModalQuery(query.toString()),
					collection,
					orders,
					way,
					group_id: formValues?.group_id,
					callback: handleModalCancel,
				});
			} else {
				onWayToGroup({
					searchQuery: removeModalQuery(query.toString()),
					way,
					group_id: formValues?.group_id,
					callback: handleModalCancel,
				});
			}
		}
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleFormSubmit();
		}
	};

	return (
		<ModalWindow
			isModalShown={isModalShown}
			onClose={handleModalCancel}
			onKeyDown={handleKeyDown}
			headerText="Переместить в группу"
			style={{ width: '695px' }}
			actionButtons={[{ type: 'close', onClick: handleModalCancel, text: 'group_change' }]}
			modalContent={<ChangeGroupModalForm groupsOptions={groupsOptions.filter(el => el.key !== group?.uid)} />}
			footerButtons={
				<ModalFooterButtons
					rightButtons={[
						{
							onClick: handleFormSubmit,
							text: 'Переместить',
							color: 'success',
							disabled: loading,
							loading,
						},
						{
							onClick: handleModalCancel,
							text: 'Отмена',
							color: 'secondary',
							disabled: loading,
						},
					]}
				/>
			}
		/>
	);
};

const withForm = reduxForm({
	form: FORM_NAME,
	enableReinitialize: true,
	onSubmit: validate,
})(ChangeGroupModalWrapper);

const mapStateToProps = createStructuredSelector({
	formValues: state => getFormValues(FORM_NAME)(state),
	isLoading: getIsLoadingSelector(),
	isOrdersGroupListLoading: getIsCollectionGroupListLoadingSelector(),
	isOrdersWayListLoading: getIsCollectionWayListLoadingSelector(),
	groupsOptions: getGroupsOptionsSelector(),
});

const mapDispatchToProps = {
	onResetForm: reset,
	onFormSubmit: submit,
	onOrderGroupToGroup: orderGroupToGroupAction,
	onOrderWayToGroup: orderWayToGroupAction,
	onGroupToGroup: groupToGroupAction,
	onWayToGroup: wayToGroupAction,
};

export const ChangeGroupModalComponent = connect(mapStateToProps, mapDispatchToProps)(withForm);

ChangeGroupModalWrapper.propTypes = {
	onFormSubmit: PropTypes.func.isRequired,
	onResetForm: PropTypes.func.isRequired,
	formValues: PropTypes.object,
	onOrderGroupToGroup: PropTypes.func.isRequired,
	onOrderWayToGroup: PropTypes.func.isRequired,
	onGroupToGroup: PropTypes.func.isRequired,
	onWayToGroup: PropTypes.func.isRequired,
	isLoading: PropTypes.bool.isRequired,
	isOrdersGroupListLoading: PropTypes.array.isRequired,
	isOrdersWayListLoading: PropTypes.array.isRequired,
	groupsOptions: PropTypes.array,
	isModalShown: PropTypes.bool,
	setIsModalShown: PropTypes.func,
	collection: PropTypes.object,
	orders: PropTypes.object,
	group: PropTypes.object,
	way: PropTypes.object,
};
